import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    PasswordMaxLength,
    RequiredFieldsValidationErrorMessage,
    RequiredFieldsValidationErrorTitle,
} from '../../../../core/constants/validator-constants';
import { PopupService } from '../popup.service';

@Component({
    selector: 'popup-reset-password',
    templateUrl:'./popup-reset-password.component.html',
    styleUrls: ['./popup-reset-password.component.scss'],
})
export class PopupResetPasswordComponent implements OnInit {
    form: FormGroup;
    showFormError = false;

    title: string = 'Reset Password';
    passwordMaxLength = PasswordMaxLength;

    userName: string;
    companyGroupName: string;
    companyName: string;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private popupService: PopupService,
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            newPassword: ['', Validators.compose([Validators.required, Validators.maxLength(this.passwordMaxLength)])],
            confirmNewPassword: ['', Validators.compose([Validators.required, Validators.maxLength(this.passwordMaxLength)])],

        },
        {
            validators: this.ComparePassword
        });
    }

    submitResetPassword(): void {
        if (this.form.invalid) {
            this.showFormError = true;
            this.popupService.alert(RequiredFieldsValidationErrorMessage, RequiredFieldsValidationErrorTitle);
            return;
        }

        this.activeModal.close({
            newPassword: this.newPassword.value,
            confirmNewPassword: this.confirmNewPassword.value
        });
    }

    cancel(): void {
        this.activeModal.dismiss();
    }

    private ComparePassword(group: FormGroup) {
        const newPassword = group.get('newPassword').value;
        const confirmNewPassword = group.get('confirmNewPassword').value;
        return newPassword === confirmNewPassword ? null : { notMatch: true };
    }

    get newPassword() {
        return this.form.get('newPassword');
    }

    get confirmNewPassword() {
        return this.form.get('confirmNewPassword');
    }
}
